import type {
  StringValidatorFn,
  StringValidatorInput,
  ValidateReturn,
} from '../formValidator.types';

export type RequiredOptions = {
  errorMessage: string;
};

const defaultOptions: RequiredOptions = { errorMessage: 'Required' };

const validateInput = (
  input: StringValidatorInput = '',
  options: Partial<RequiredOptions> = defaultOptions,
): ValidateReturn => {
  const opts = { ...defaultOptions, ...options };
  const stringInput = input || '';
  return !stringInput?.trim() ? opts.errorMessage : undefined;
};

export const validateRequired = (input: StringValidatorInput): ValidateReturn =>
  validateInput(input);

export const getValidateRequiredFn = (
  options: Partial<RequiredOptions>,
): StringValidatorFn => {
  return (input: StringValidatorInput) => validateInput(input, options);
};
